var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
import Input from '../input';
import { Styled } from './style';
var MultilineInput = /** @class */ (function (_super) {
    __extends(MultilineInput, _super);
    function MultilineInput(props) {
        var _this = _super.call(this, props) || this;
        _this.formatInput = function (input) {
            var regex = /(\d{2}:\d{2} *- *\d{2}:\d{2})/;
            var parsedTime = input.match(regex);
            if (parsedTime) {
                return parsedTime[0];
            }
            return null;
        };
        _this.handleBlur = function (event) {
            var element = event.target;
            var id = element.id;
            var updatedInputs = _this.state.inputs;
            var formattedValue = _this.formatInput(element.value);
            if (!formattedValue) {
                return;
            }
            updatedInputs[id].className = 'blurred';
            updatedInputs[id].value = formattedValue;
            _this.setState({
                inputs: updatedInputs,
            });
            if (_this.props.callback) {
                _this.props.callback(updatedInputs);
            }
        };
        _this.toggleBlur = function (event) {
            var element = event.target;
            var id = element.id;
            var updatedInputs = _this.state.inputs;
            updatedInputs[id].className = '';
            updatedInputs[id].value = '';
            _this.setState({
                inputs: updatedInputs,
            });
        };
        _this.addInput = function () {
            _this.setState({
                inputs: _this.state.inputs.concat({
                    value: '',
                }),
            });
        };
        _this.handleChange = function (event) {
            var element = event.target;
            var id = element.id;
            var inputs = _this.state.inputs;
            inputs[id].value = element.value;
            _this.setState({
                inputs: inputs,
            });
        };
        _this.removeInput = function (id) {
            if (id === 0) {
                return;
            }
            var updatedInputs = _this.state.inputs.filter(function (input, index) { return index !== id; });
            _this.setState({
                inputs: updatedInputs,
            });
            if (_this.props.callback) {
                _this.props.callback(updatedInputs);
            }
        };
        _this.state = {
            inputs: [{ value: '' }],
        };
        return _this;
    }
    MultilineInput.getDerivedStateFromProps = function (props, state) {
        if (props.defaultValues && props.defaultValues.length > 0) {
            var newInputs = props.defaultValues.map(function (value) { return ({ value: value, className: 'blurred' }); });
            return { inputs: newInputs };
        }
        return null;
    };
    MultilineInput.prototype.render = function () {
        var _this = this;
        var inputs = this.state.inputs;
        var placeholder = 'hh:mm - hh:mm';
        return (React.createElement(Styled, null, inputs.map(function (input, index) { return (React.createElement("div", { key: index, className: "item-row" },
            React.createElement(Input, { className: input.className, id: index, tabIndex: index, placeholder: placeholder, type: "text", value: input.value, onBlur: function (event) { return _this.handleBlur(event); }, onClick: _this.toggleBlur, onChange: _this.handleChange }),
            React.createElement(Button, { onClick: function () {
                    _this.removeInput(index);
                }, icon: true },
                React.createElement(Icon, { name: "trash" })),
            React.createElement(Button, { onClick: _this.addInput, icon: true },
                React.createElement(Icon, { name: "plus-fill" })))); })));
    };
    return MultilineInput;
}(React.Component));
export { MultilineInput };
export default MultilineInput;
//# sourceMappingURL=index.js.map